import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// The module loads on first visit as one section; its screens split further inside it (HomeServicesSection.tsx)
const HomeServicesSection = lazyRoute(() => import('./HomeServicesSection').then((m) => m.HomeServicesSection));
const ServiceRequestPage = lazyRoute(() => import('./public/ServiceRequestPage').then((m) => m.ServiceRequestPage));
const EstimatePage = lazyRoute(() => import('./public/EstimatePage').then((m) => m.EstimatePage));

/** Home services (dispatch, jobs, estimates, team, plans, reports, settings), under /agencies/:agencyId/home_services */
export const homeServicesAgencyRoutes = <Route path="home_services/*" element={<HomeServicesSection />} />;

/** Customer-facing (no sign-in): the service request page and the estimate page (token in the URL fragment) */
export const homeServicesPublicRoutes = (
  <>
    <Route path="/book/:pageSlug/service" element={<ServiceRequestPage />} />
    <Route path="/estimate" element={<EstimatePage />} />
  </>
);
